export default function Contact() {
  return null;
}
